import React from 'react';
const testimonials = [{
  text: '"La técnica de la bandeja invertida cambió todo. Mi familia ya no pide delivery."',
  name: 'Marcos G.',
  loc: 'Argentina',
  initial: 'M'
}, {
  text: '"Por fin entendí por qué mi masa siempre quedaba mal. Ahora me sale perfecta cada vez."',
  name: 'Laura M.',
  loc: 'México',
  initial: 'L'
}, {
  text: '"Mi pizza con sourdough de 72h es lo mejor que he comido en mi vida. Y lo hice en casa."',
  name: 'Carlos R.',
  loc: 'Colombia',
  initial: 'C'
}];
export function Testimonials() {
  return <div className="py-6 px-5" data-id="element-149">
      <div className="max-w-5xl mx-auto" data-id="element-150">
        <h2 className="font-serif text-xl sm:text-2xl text-[#C0392B] text-center mb-1 uppercase tracking-wider" data-id="element-151">
          Lo que Dicen los Maestros
        </h2>
        <div className="w-16 h-0.5 bg-gradient-to-r from-[#C0392B] to-[#F1C40F] mx-auto rounded my-2" data-id="element-152" />

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4" data-id="element-153">
          {testimonials.map((t, i) => <div key={i} className="bg-[#1A1A1A] border border-[#C0392B]/25 rounded-lg p-4" data-id="element-154">
              <div className="text-[#F1C40F] text-sm mb-1" data-id="element-155">★★★★★</div>
              <p className="text-[#DDDDDD] italic text-[11px] leading-relaxed mb-3" data-id="element-156">
                {t.text}
              </p>
              <div className="flex items-center gap-2" data-id="element-157">
                <div className="w-7 h-7 bg-[#C0392B] rounded-full flex items-center justify-center text-white font-bold text-xs" data-id="element-158">
                  {t.initial}
                </div>
                <div data-id="element-159">
                  <div className="text-[#F1C40F] text-[10px] font-bold" data-id="element-160">
                    {t.name}
                  </div>
                  <div className="text-[#666] text-[9px]" data-id="element-161">{t.loc}</div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}